<template>
  <v-overlay
    :value="internalShow" :z-index="zIndex"
    attach="body"
    absolute
    style="position: fixed !important; top: 0; left: 0; width: 100vw; height: 100vh;"
  >
    <div class="text-center">
      <v-progress-circular
        :size="size"
        :width="width"
        color="pink lighten-2"
        indeterminate
      />
      <div v-if="message" class="mt-3 white--text font-weight-medium">
        {{ message }}
      </div>
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 48
    },
    width: {
      type: Number,
      default: 4
    },
    zIndex: {
      type: Number,
      default: 999
    },
    minDisplayTime: {
      type: Number,
      default: 500 
    }
  },
  data() {
    return {
      internalShow: false,
      hideTimeout: null,
      showStartTime: null
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.internalShow = true;
        this.showStartTime = Date.now(); 
      } else {
        const elapsedTime = Date.now() - this.showStartTime;
        if (elapsedTime < this.minDisplayTime) {
          this.hideTimeout = setTimeout(() => {
            this.internalShow = false;
          }, this.minDisplayTime - elapsedTime);
        } else {
          this.internalShow = false;
        }
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.hideTimeout);
  }
}
</script>